import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import { store } from "@/store/index";

Vue.use(VueRouter);

export const createRouter = () => {
  // Routes for tvAnalys (non-VideoInHome) with relative child paths.
  const tvAnalysRoutes = {
    path: "/",
    name: "Home",
    component: Home,
    children: [
      {
        // default child route (renders Landing)
        path: "",
        component: () => import("@/components/Layout/Landing/Landing")
      },
      {
        path: "toplist",
        component: () => import("@/components/Layout/Toplist/Toplist"),
        meta: {
          tabQuery: "Toplist",
          tabText: "Top List"
        }
      },
      {
        path: "programs",
        component: () => import("@/components/Layout/Programs/Programs"),
        meta: {
          tabQuery: "Programs",
          tabText: "Program"
        }
      },
      {
        path: "campaigns",
        component: () => import("@/components/Layout/Campaigns/Campaigns"),
        meta: {
          tabQuery: "Campaigns",
          tabText: "Ad"
        }
      },
      {
        path: "channels",
        component: () => import("@/components/Layout/Channels/Channels"),
        meta: {
          tabQuery: "Channels",
          tabText: "Channel"
        }
      },
      {
        path: "videoinhome",
        component: () => import("@/components/Layout/Streaming/Streaming"),
        meta: {
          tabQuery: "Streaming",
          tabText: "Video In Home"
        }
      }
    ]
  };

  // Routes for VideoInHome (if applicable)
  const videoInHomeRoute = {
    path: "/",
    name: "Home",
    component: Home,
    children: [
      {
        // default child route for VideoInHome
        path: "",
        name: "VideoInHome",
        component: () => import("@/components/Layout/Streaming/Streaming"),
        meta: {
          tabQuery: "Streaming",
          tabText: "Video In Home"
        }
      }
    ]
  };

  // Choose the proper route set based on subdomain
  const routes = [
    store.getters.getIsVideoInHomeSubdomain ? videoInHomeRoute : tvAnalysRoutes,
    {
      path: "/maintenance",
      name: "Maintenance",
      component: () => import("@/views/Maintenance.vue")
    }
  ];

  const router = new VueRouter({
    mode: "history",
    routes
  });

  router.beforeEach((to, from, next) => {
    const isVideoInHome = store.getters.getIsVideoInHomeSubdomain;
    // For VideoInHome, force the root path ("/")
    if (isVideoInHome && to.path !== "/" && to.path !== "/maintenance") {
      return next("/");
    }
    document.title = isVideoInHome ? "MMS - VIDEO IN HOME" : "MMS - BROADCAST";
    next();
  });

  router.afterEach(() => {
    store.dispatch("checkCookieConsent");
  });

  return router;
};
